import React from 'react';
import { connect } from 'react-redux';

import { Form } from "components/common";
import MainFieldSet from './MainFieldSet';


const CityForm = (props) => {
  const { showEditForm } = props.city;

  const onClose = () => {
    props.actions.city.showEditForm({ show: false });
  };

  const onSubmit = data => {
    props.actions.city.update(data);
  };

  return (
    <Form
      title="Редактирование города"
      name="cityForm"
      model={props.city}
      visible={showEditForm}
      onClose={onClose}
      onSubmit={onSubmit}
    >
      <MainFieldSet {...props}/>
    </Form>
  )
};

const mapState = state => ({
  city: state.city,
});

const mapDispatch = dispatch => ({
  actions: {
    city: dispatch.city,
  }
});

export default connect(mapState, mapDispatch)(CityForm);
